import AccessPointIcon from './collection/AccessPointIcon';
import ActionsIcon from './collection/ActionsIcon';
import AddIcon from './collection/AddIcon';
import AlarmActiveIcon from './collection/AlarmActiveIcon';
import AlarmIcon from './collection/AlarmIcon';
import AlarmInverseIcon from './collection/AlarmInverseIcon';
import AlphabeticSortIcon from './collection/AlphabeticSortIcon';
import AnprColumnIcon from './collection/AnprColumnIcon';
import ArrowDownIcon from './collection/ArrowDownIcon';
import ArrowLeftIcon from './collection/ArrowLeftIcon';
import ArrowUpIcon from './collection/ArrowUpIcon';
import AssetsActiveIcon from './collection/AssetsActiveIcon';
import AssetsIcon from './collection/AssetsIcon';
import AssetsRequestDarkIcon from './collection/AssetsRequestDarkIcon';
import AssetsRequestsIcon from './collection/AssetsRequestsIcon';
import AssetsRequestsLightIcon from './collection/AssetsRequestsLightIcon';
import AssetTypesManagementIcon from './collection/AssetTypesManagementIcon';
import AttachIcon from './collection/AttachIcon';
import AttributesIcon from './collection/AttributesIcon';
import BackIcon from './collection/BackIcon';
import BagIcon from './collection/BagIcon';
import BenchIcon from './collection/BenchIcon';
import BinIcon from './collection/BinIcon';
import BuildingIcon from './collection/BuildingIcon';
import BusStopIcon from './collection/BusStopIcon';
import Calculator from './collection/Calculator';
import CalendarDisabledIcon from './collection/CalendarDisabledIcon';
import CalendarIcon from './collection/CalendarIcon';
import CalendarWhiteIcon from './collection/CalendarWhiteIcon';
import CctvIcon from './collection/CctvIcon';
import ChartsOnMapIcon from './collection/ChartsOnMapIcon';
import CheckIcon from './collection/CheckIcon';
import CheckMarkWhiteIcon from './collection/CheckMark';
import CheckMarkIcon from './collection/CheckMarkIcon';
import ChevronDownIcon from './collection/ChevronDownIcon';
import ChevronLeftIcon from './collection/ChevronLeftIcon';
import ChevronRightIcon from './collection/ChevronRightIcon';
import ChevronsIcon from './collection/ChevronsIcon';
import ChevronsLeftIcon from './collection/ChevronsLeftIcon';
import ChevronsRightIcon from './collection/ChevronsRightIcon';
import ChevronUpIcon from './collection/ChevronUpIcon';
import CircleIcon from './collection/CircleIcon';
import CirclePolygonIcon from './collection/CirclePolygonIcon';
import ClearDataIcon from './collection/ClearDataIcon';
import ClearFilesIcon from './collection/ClearFilesIcon';
import ClearGroupSelectIcon from './collection/ClearGroupSelectIcon';
import ClearMultiselectIcon from './collection/ClearMultiselectIcon';
import ClipIcon from './collection/ClipIcon';
import CloseIcon from './collection/CloseIcon';
import CMModuleIcon from './collection/CMModuleIcon';
import CMModuleWhiteIcon from './collection/CMModuleWhiteIcon';
import CommonLocationIcon from './collection/CommonLocationIcon';
import ConfigurationIcon from './collection/ConfigurationIcon';
import ConfigurationOutlineIcon from './collection/ConfigurationOutlineIcon';
import ConsistencyIcon from './collection/ConsistencyIcon';
import ConsistencyIconActive from './collection/ConsistencyIconActive';
import ConvertIcon from './collection/ConvertIcon';
import CopyIcon from './collection/CopyIcon';
import CreateIcon from './collection/CreateIcon';
import CrossIcon from './collection/CrossIcon';
import CrowdCellActive from './collection/CrowdCellActiveIcon';
import CrowdCellIcon from './collection/CrowdCellIcon';
import CrowdCellInverseIcon from './collection/CrowdCellInverseIcon';
import DashboardIcon from './collection/DashboardIcon';
import DecreaseIcon from './collection/DecreaseIcon';
import DeleteCustomColorIcon from './collection/DeleteCustomColorIcon';
import DeleteIcon from './collection/DeleteIcon';
import DescriptionIcon from './collection/DescriptionIcon';
import DigitalSignageIcon from './collection/DigitalSignageIcon';
import DisketteIcon from './collection/DisketteIcon';
import DownloadFileIcon from './collection/DownloadFileIcon';
import DragHandleIcon from './collection/DragHandleIcon';
import DropdownIcon from './collection/DropdownIcon';
import EarthIcon from './collection/EarthIcon';
import EditCircleIcon from './collection/EditCircleIcon';
import EditCustomColorIcon from './collection/EditCustomColorIcon';
import EditIcon from './collection/EditIcon';
import EmailIcon from './collection/EmailIcon';
import EnvelopeIcon from './collection/EnvelopeIcon';
import ErrorIcon from './collection/ErrorIcon';
import ErrorPlateActiveIcon from './collection/ErrorPlateActiveIcon';
import ErrorPlateIcon from './collection/ErrorPlateIcon';
import ExpandIcon from './collection/ExpandIcon';
import ExportCloudIcon from './collection/ExportCloudIcon';
import ExportFileIcon from './collection/ExportFileIcon';
import ExportTransparentIcon from './collection/ExportTransparentIcon';
import ExternalRedirectIcon from './collection/ExternalRedirectIcon';
import EyeClosedIcon from './collection/EyeClosedIcon';
import EyeOpenedIcon from './collection/EyeOpenedIcon';
import FavoriteIcon from './collection/FavoriteIcon';
import FileDownloadIcon from './collection/FileDownloadIcon';
import FileIcon from './collection/FileIcon';
import FilterIcon from './collection/FilterIcon';
import FiveGIcon from './collection/FiveGIcon';
import FolderEmptyIcon from './collection/FolderEmptyIcon';
import FolderIcon from './collection/FolderIcon';
import FullViewIcon from './collection/FullViewIcon';
import GuidelineIcon from './collection/GuidelineIcon';
import HalfCheckIcon from './collection/HalfCheckIcon';
import HandIcon from './collection/HandIcon';
import HistoryIcon from './collection/HistoryIcon';
import ImportIcon from './collection/ImportIcon';
import IncomingRequestActiveIcon from './collection/IncomingRequestAcitiveIcon';
import IncomingRequestIcon from './collection/IncomingRequestIcon';
import IncomingRequestLightIcon from './collection/IncomingRequestLight';
import IncreaseIcon from './collection/IncreaseIcon';
import InfoIcon from './collection/InfoIcon';
import InterlinkIcon from './collection/InterlinkIcon';
import KaiAssistantIcon from './collection/KaiAssistantIcon';
import KpiIcon from './collection/KpiIcon';
import KpiNotificationsIcon from './collection/KpiNotificationsIcon';
import KpiNotificationsOutlineIcon from './collection/KpiNotificationsOutlineIcon';
import KpiOutlineIcon from './collection/KpiOutlineIcon';
import LampPostIcon from './collection/LampPostIcon';
import LandIcon from './collection/LandIcon';
import LayerIcon from './collection/LayerIcon';
import LinkIcon from './collection/LinkIcon';
import ListIcon from './collection/ListIcon';
import ListWhiteIcon from './collection/ListWhiteIcon';
import LocationIcon from './collection/LocationIcon';
import LocationLinkIcon from './collection/LocationLinkIcon';
import LocationMarkIcon from './collection/LocationMarkIcon';
import LocationTransparentIcon from './collection/LocationTransparentIcon';
import LogoIcon from './collection/LogoIcon';
import LogoStubIcon from './collection/LogoStubIcon';
import LogoStubSquareIcon from './collection/LogoStubSquareIcon';
import LogOutIcon from './collection/LogOutIcon';
import LteFddIcon from './collection/LteFddIcon';
import LteTddIcon from './collection/LteTddIcon';
import ManageAllSiteDBIcon from './collection/ManageAllSiteDBIcon';
import ManageAllSiteDBInverseIcon from './collection/ManageAllSiteDBInverseIcon';
import ManageSiteDBIcon from './collection/ManageSiteDBIcon';
import ManageSiteDBInverseIcon from './collection/ManageSiteDBInverseIcon';
import MapActiveIcon from './collection/MapActiveIcon';
import MapIcon from './collection/MapIcon';
import MenuIcon from './collection/MenuIcon';
import MiddlewareSMOIcon from './collection/MiddlewareSMOIcon';
import NotificationActiveIcon from './collection/NotificationActiveIcon';
import NotificationFilledIcon from './collection/NotificationFilledIcon';
import NotificationIcon from './collection/NotificationIcon';
import OutgoingRequestActiveIcon from './collection/OutgoingRequestActiveIcon';
import OutgoingRequestIcon from './collection/OutgoingRequestIcon';
import OutgoingRequestLightIcon from './collection/OutgoingRequestLightIcon';
import OwnerIcon from './collection/OwnerIcon';
import PaperTabletActiveIcon from './collection/PaperTabletActiveIcon';
import PaperTabletIcon from './collection/PaperTabletIcon';
import PhoneIcon from './collection/PhoneIcon';
import PinIcon from './collection/PinIcon';
import PlusIcon from './collection/PlusIcon';
import PolygonIcon from './collection/PolygonIcon';
import PopsIcon from './collection/PopsIcon';
import PortalIcon from './collection/PortalIcon';
import RefreshIcon from './collection/RefreshIcon';
import RemoveIcon from './collection/RemoveIcon';
import ReportsIcon from './collection/ReportsIcon';
import RequestCartActiveIcon from './collection/RequestCartActiveIcon';
import RequestCartIcon from './collection/RequestCartIcon';
import ResetIcon from './collection/ResetIcon';
import RevertIcon from './collection/RevertIcon';
import SaveIcon from './collection/SaveIcon';
import SearchFilterIcon from './collection/SearchFilterIcon';
import SearchIcon from './collection/SearchIcon';
import SectorsIcon from './collection/SectorsIcon';
import SetIcon from './collection/SetIcon';
import SettingsIcon from './collection/SettingsIcon';
import SettingsPaintedIcon from './collection/SettingsPaintedIcon';
import SettingsWhiteIcon from './collection/SettingsWhiteIcon';
import SitesFilterIcon from './collection/SitesFilterIcon';
import SlidersIcon from './collection/SlidersIcon';
import SmallWarningIcon from './collection/SmallWarningIcon';
import SpeedTestIcon from './collection/SpeedTestIcon';
import StarIcon from './collection/StarIcon';
import StopIcon from './collection/StopIcon';
import StreetSignIcon from './collection/StreetSignIcon';
import SuccessIcon from './collection/SuccessIcon';
import SummaryIcon from './collection/SummaryIcon';
import SweepIcon from './collection/Sweep';
import TableIcon from './collection/TableIcon';
import TableIconActive from './collection/TableIconActive';
import TargetIcon from './collection/TargetIcon';
import taskDoneIcon from './collection/TaskDoneIcon';
import taskInProgressIcon from './collection/TaskInProgressIcon';
import taskToDoIcon from './collection/TaskToDoIcon';
import TflStationsIcon from './collection/TflStationsIcon';
import ThresholdManagementActiveIcon from './collection/ThresholdManagementActiveIcon';
import ThresholdManagementIcon from './collection/ThresholdManagementIcon';
import ThresholdManagementInverseIcon from './collection/ThresholdManagementInverseIcon';
import ThumbsUp from './collection/ThumbsUp';
import TrafficLightIcon from './collection/TrafficLightIcon';
import TrafficSignIcon from './collection/TrafficSignIcon';
import TriangleDownIcon from './collection/TriangleDownIcon';
import TriangleLeftIcon from './collection/TriangleLeftIcon';
import TriangleRightIcon from './collection/TriangleRightIcon';
import TriangleUpIcon from './collection/TriangleUpIcon';
import UncheckIcon from './collection/UncheckIcon';
import UncheckWhiteIcon from './collection/UncheckWhiteIcon';
import UnknownLargeIcon from './collection/UnknownLargeIcon';
import UnlinkIcon from './collection/UnlinkIcon';
import UnpinIcon from './collection/UnpinIcon';
import UploadAvatarIcon from './collection/UploadAvatarIcon';
import UploadedFileIcon from './collection/UploadedFileIcon';
import UploadFileIcon from './collection/UploadFileIcon';
import UploadImageIcon from './collection/UploadImageIcon';
import UserIcon from './collection/UserIcon';
import UsersFilledIcon from './collection/UsersFilledIcon';
import UsersIcon from './collection/UsersIcon';
import VendorsIcon from './collection/VendorsIcon';
import VerifyCoordinatesActiveIcon from './collection/VerifyCoordinatesActiveIcon';
import VerifyCoordinatesIcon from './collection/VerifyCoordinatesIcon';
import ViewIcon from './collection/ViewIcon';
import ViewLinkIcon from './collection/ViewLinkIcon';
import WarningIcon from './collection/WarningIcon';
import WarningIconActive from './collection/WarningIconActive';

export const Icons = {
	accessPoint: AccessPointIcon,
	actions: ActionsIcon,
	add: AddIcon,
	alarm: AlarmIcon,
	alarmActive: AlarmActiveIcon,
	alarmInverse: AlarmInverseIcon,
	alphabeticSortIcon: AlphabeticSortIcon,
	anprColumn: AnprColumnIcon,
	arrowDown: ArrowDownIcon,
	arrowLeft: ArrowLeftIcon,
	arrowUp: ArrowUpIcon,
	assetTypesManagement: AssetTypesManagementIcon,
	assets: AssetsIcon,
	assetsActive: AssetsActiveIcon,
	assetsRequestDark: AssetsRequestDarkIcon,
	assetsRequests: AssetsRequestsIcon,
	assetsRequestsLight: AssetsRequestsLightIcon,
	attachIcon: AttachIcon,
	attributesIcon: AttributesIcon,
	back: BackIcon,
	bag: BagIcon,
	bench: BenchIcon,
	bin: BinIcon,
	building: BuildingIcon,
	busStop: BusStopIcon,
	calculator: Calculator,
	calendar: CalendarIcon,
	calendarDisabled: CalendarDisabledIcon,
	calendarWhite: CalendarWhiteIcon,
	cartRequest: RequestCartIcon,
	cartRequestActive: RequestCartActiveIcon,
	cctv: CctvIcon,
	chartsOnMap: ChartsOnMapIcon,
	check: CheckIcon,
	checkIcon: CheckIcon,
	checkMark: CheckMarkIcon,
	checkMarkWhite: CheckMarkWhiteIcon,
	chevronDown: ChevronDownIcon,
	chevronLeft: ChevronLeftIcon,
	chevronRight: ChevronRightIcon,
	chevronUp: ChevronUpIcon,
	chevrons: ChevronsIcon,
	chevronsLeft: ChevronsLeftIcon,
	chevronsRight: ChevronsRightIcon,
	circle: CircleIcon,
	circlePolygon: CirclePolygonIcon,
	clearDataIcon: ClearDataIcon,
	clearGroupSelect: ClearGroupSelectIcon,
	clearMultiselect: ClearMultiselectIcon,
	clip: ClipIcon,
	close: CloseIcon,
	cmModule: CMModuleIcon,
	cmModuleWhite: CMModuleWhiteIcon,
	commonLocationIcon: CommonLocationIcon,
	configurationIcon: ConfigurationIcon,
	configurationIconOutline: ConfigurationOutlineIcon,
	consistency: ConsistencyIcon,
	consistencyActive: ConsistencyIconActive,
	convertIcon: ConvertIcon,
	copy: CopyIcon,
	cross: CrossIcon,
	crowdCell: CrowdCellIcon,
	crowdCellActive: CrowdCellActive,
	crowdCellInverse: CrowdCellInverseIcon,
	dashboardIcon: DashboardIcon,
	decreaseIcon: DecreaseIcon,
	delete: DeleteIcon,
	deleteCustomColor: DeleteCustomColorIcon,
	description: DescriptionIcon,
	dragHandle: DragHandleIcon,
	digitalSignage: DigitalSignageIcon,
	diskette: DisketteIcon,
	downloadFileIcon: DownloadFileIcon,
	dropdownIcon: DropdownIcon,
	earthIcon: EarthIcon,
	editCircle: EditCircleIcon,
	editCustomColor: EditCustomColorIcon,
	createIcon: CreateIcon,
	editIcon: EditIcon,
	emailIcon: EmailIcon,
	envelopeIcon: EnvelopeIcon,
	errorIcon: ErrorIcon,
	errorPlateActiveIcon: ErrorPlateActiveIcon,
	errorPlateIcon: ErrorPlateIcon,
	expandIcon: ExpandIcon,
	export: ExportFileIcon,
	exportIcon: ExportCloudIcon,
	exportIconTransparent: ExportTransparentIcon,
	externalRedirect: ExternalRedirectIcon,
	eyeClose: EyeClosedIcon,
	eyeOpen: EyeOpenedIcon,
	favoriteIcon: FavoriteIcon,
	file: FileIcon,
	fileDownloadIcon: FileDownloadIcon,
	fileIcon: FileIcon,
	portalIcon: PortalIcon,
	filter: FilterIcon,
	fiveG: FiveGIcon,
	folderIcon: FolderIcon,
	folderEmpty: FolderEmptyIcon,
	fullView: FullViewIcon,
	guidelineIcon: GuidelineIcon,
	halfCheck: HalfCheckIcon,
	hand: HandIcon,
	history: HistoryIcon,
	import: ImportIcon,
	incomingRequest: IncomingRequestIcon,
	incomingRequestActive: IncomingRequestActiveIcon,
	incomingRequestLight: IncomingRequestLightIcon,
	increaseIcon: IncreaseIcon,
	info: InfoIcon,
	interlink: InterlinkIcon,
	kaiAssistant: KaiAssistantIcon,
	kpiIcon: KpiIcon,
	kpiIconOutline: KpiOutlineIcon,
	kpiNotifications: KpiNotificationsIcon,
	kpiNotificationsOutline: KpiNotificationsOutlineIcon,
	lamppost: LampPostIcon,
	land: LandIcon,
	layer: LayerIcon,
	link: LinkIcon,
	list: ListIcon,
	listWhite: ListWhiteIcon,
	location: LocationMarkIcon,
	locationIcon: LocationIcon,
	locationLink: LocationLinkIcon,
	locationTransparent: LocationTransparentIcon,
	logOutIcon: LogOutIcon,
	logo: LogoIcon,
	logoStub: LogoStubIcon,
	logoStubSquare: LogoStubSquareIcon,
	lteFdd: LteFddIcon,
	lteTdd: LteTddIcon,
	manageAllSiteDB: ManageAllSiteDBIcon,
	manageAllSiteDBInverse: ManageAllSiteDBInverseIcon,
	manageSiteDB: ManageSiteDBIcon,
	manageSiteDBInverse: ManageSiteDBInverseIcon,
	map: MapIcon,
	mapActive: MapActiveIcon,
	menu: MenuIcon,
	middlewareSMO: MiddlewareSMOIcon,
	notification: NotificationIcon,
	notificationActive: NotificationActiveIcon,
	notificationFilled: NotificationFilledIcon,
	outgoingRequest: OutgoingRequestIcon,
	outgoingRequestActive: OutgoingRequestActiveIcon,
	outgoingRequestLight: OutgoingRequestLightIcon,
	owner: OwnerIcon,
	paperTabledActive: PaperTabletActiveIcon,
	paperTablet: PaperTabletIcon,
	phoneIcon: PhoneIcon,
	pin: PinIcon,
	plus: PlusIcon,
	polygon: PolygonIcon,
	pops: PopsIcon,
	refresh: RefreshIcon,
	removeIcon: RemoveIcon,
	reports: ReportsIcon,
	resetIcon: ResetIcon,
	revert: RevertIcon,
	saveIcon: SaveIcon,
	search: SearchIcon,
	searchFilter: SearchFilterIcon,
	sectorsIcon: SectorsIcon,
	set: SetIcon,
	settings: SettingsIcon,
	settingsPainted: SettingsPaintedIcon,
	settingsWhite: SettingsWhiteIcon,
	sitesFilterIcon: SitesFilterIcon,
	slidersIcon: SlidersIcon,
	smallWarningIcon: SmallWarningIcon,
	speedTest: SpeedTestIcon,
	star: StarIcon,
	stopIcon: StopIcon,
	streetSign: StreetSignIcon,
	successIcon: SuccessIcon,
	summaryIcon: SummaryIcon,
	sweep: SweepIcon,
	taskToDo: taskToDoIcon,
	taskInProgress: taskInProgressIcon,
	taskDone: taskDoneIcon,
	tableIcon: TableIcon,
	tableIconActive: TableIconActive,
	target: TargetIcon,
	tflStations: TflStationsIcon,
	thumbsUp: ThumbsUp,
	thresholdManagement: ThresholdManagementIcon,
	thresholdManagementActive: ThresholdManagementActiveIcon,
	thresholdManagementInverse: ThresholdManagementInverseIcon,
	trafficLight: TrafficLightIcon,
	trafficSign: TrafficSignIcon,
	triangleLeft: TriangleLeftIcon,
	triangleRight: TriangleRightIcon,
	triangleDown: TriangleDownIcon,
	triangleUp: TriangleUpIcon,
	uncheck: UncheckIcon,
	uncheckIcon: UncheckWhiteIcon,
	unknownLarge: UnknownLargeIcon,
	unlink: UnlinkIcon,
	unpin: UnpinIcon,
	uploadAvatarIcon: UploadAvatarIcon,
	uploadFile: UploadFileIcon,
	uploadImage: UploadImageIcon,
	uploadedFile: UploadedFileIcon,
	userIcon: UserIcon,
	users: UsersFilledIcon,
	usersIcon: UsersIcon,
	vendors: VendorsIcon,
	verifyCoordinates: VerifyCoordinatesIcon,
	verifyCoordinatesActive: VerifyCoordinatesActiveIcon,
	viewIcon: ViewIcon,
	viewLink: ViewLinkIcon,
	warningIcon: WarningIcon,
	warningIconActive: WarningIconActive,
	clearFilesIcon: ClearFilesIcon,
};
